import { makeRequest } from "./api";

// Create a Coupon
export const createCoupon = async (data) => {
  return makeRequest("/api/admin/manage/coupons", {
    method: "POST",
    data,
  });
};

// List All Coupons
export const getCoupons = async () => {
  return makeRequest("/api/admin/manage/coupons");
};

// Get Coupon Details
export const getCoupon = async (id) => {
  return makeRequest(`/api/admin/manage/coupons/${id}`);
};

// Update a Coupon
export const updateCoupon = async (id, data) => {
  return makeRequest(`/api/admin/manage/coupons/${id}`, {
    method: "PUT",
    data,
  });
};

// Delete a Coupon
export const deleteCoupon = async (id) => {
  return makeRequest(`/api/admin/manage/coupons/${id}`, {
    method: "DELETE",
  });
};
